import Image from './Image';
import MultilangText from './MultilangText';
import ChargeType from './ChargeType';

export default class Addon {
  id!: string;
  productId!: string;
  roomId!: string;
  packageId!: string;
  name!: MultilangText;
  images!: Image[];
  description!: MultilangText;
  chargeType!: ChargeType;
  weekAvailability!: number[];
  maxQtyPerReservation!: number;
  available!: string;
  isFixedRate!: boolean;
  quantity!: number;
  rate!: number;
  rateWithInclusive!: number;
  totalRate!: number;
  totalRateWithInclusive!: number;
  totalTaxes!: number;
  totalFees!: number;
  grandTotal!: number;
  taxesGroupedById!: any[];
  feesGroupedById!: any[];
  taxesArray!: any[];
  feesArray!: any[];
  dailyRates!: any[];
  priceSettings!: string;
  postingStrategy!: string;
  currentStock!: string;
  doNotTrack!: boolean;
  stopSelling!: any;
  productType!: string;

  constructor(data: undefined | any = {}) {
    if (!data) return;

    this.id = data.addonId.toString();
    this.productId = data.productId.toString();
    this.roomId = data.roomId.toString();
    this.packageId = data.packageId.toString();
    this.name = new MultilangText(data.addonName);
    this.images = [];
    for (let i = 0; i < data.addonPhotos.length; i++) {
      this.images.push(new Image(data.addonPhotos[i]));
    }
    this.description = new MultilangText(data.addonDescription);
    this.chargeType = data.chargeType as ChargeType;
    this.weekAvailability = data.weekAvailability;
    this.maxQtyPerReservation = data.maxQtyPerReservation || 0;
    this.available = data.available;
    this.isFixedRate = data.isFixedPrice === 1;
    this.quantity = data.qty;
    this.rate = data.price;
    this.rateWithInclusive = data.priceWithInclusive;
    this.totalRate = data.totalPrice;
    this.totalRateWithInclusive = data.totalPriceWithInclusive;
    this.totalTaxes = data.totalTaxes;
    this.totalFees = data.totalFees;
    this.grandTotal = data.grandTotal;
    this.taxesGroupedById = data.taxesGroupedById;
    this.feesGroupedById = data.feesGroupedById;
    this.taxesArray = data.taxesArray;
    this.feesArray = data.feesArray;
    this.dailyRates = data.dailyRates;
    this.priceSettings = data.priceSettings;
    this.postingStrategy = data.postingStrategy;
    this.currentStock = data.currentStock;
    this.doNotTrack = data.doNotTrack === 1;
    this.stopSelling = data.stopSelling;
    this.productType = data.productType;
  }
}
